import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbaseClient';

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setUser(pb.authStore.model);
    setLoading(false);
    return pb.authStore.onChange(() => setUser(pb.authStore.model));
  }, []);

  const login = async (email, password) => {
    const authData = await pb.collection('users').authWithPassword(email, password);
    const userRole = authData.record?.role;
    // Only allow admin or super_admin
    if (userRole !== 'admin' && userRole !== 'super_admin') {
      throw new Error('Access denied. Admin only.');
    }
    setUser(authData.record);
    return authData;
  };

  const logout = () => {
    pb.authStore.clear();
    setUser(null);
  };

  const value = {
    user,
    loading,
    isAuthenticated: !!user,
    login,
    logout,
    role: user?.role || 'guest',
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AdminAuthProvider');
  }
  return context;
};